import { createMachine } from "xstate";

export const attentionMachine = createMachine({
  id: "attention-round",
  initial: "idle",
  states: {
    idle: {
      on: { CONSENT: "priming", START: "running" }
    },
    priming: {
      on: { START: "running", RESET: "idle" }
    },
    running: {
      on: { STOP: "reveal", RESET: "idle" }
    },
    reveal: {
      on: { SAVE: "completed", RESTART: "running", RESET: "idle" }
    },
    completed: {
      on: { ARCHIVE: "archived", RESTART: "running", RESET: "idle" }
    },
    archived: {
      on: { RESTART: "running", RESET: "idle" }
    }
  }
});
